<template>
    <div
        id="helpPage"
        class="d-flex flex-column justify-content-center p-0 bg-white"
    >
        <div class="d-flex flex-column px-4 pt-4">
            <span class="font-md font-weight-bold text-gray-dk text-capitalize"
                >Help</span
            >
            <span
                class="font-sm font-weight-bold text-gray-dk text-capitalize my-3"
                >How-To videos</span
            >
            <div
                v-for="video in videos"
                :key="video.key"
                @click="redirectToLink(video.link)"
                class="d-flex justify-content-between my-3 p-0 clickable"
            >
                <span class="font-sm font-weight-bold text-success">{{
                    video.title
                }}</span>
                <img
                    alt=""
                    src="/img/hcpay/chevron-right.svg"
                    class="chevronIcon img-responsive"
                />
            </div>
        </div>
        <template v-if="qualtricsEnabled">
            <hr class="mb-4" />
            <div class="d-flex flex-column px-4 py-1">
                <span
                    class="font-sm font-weight-bold text-gray-dk text-capitalize"
                    >Help Us Improve</span
                >
                <span class="font-sm text-secondary mt-3 mb-4"
                    >Share your ideas, suggestions, or report a bug</span
                >
                <div class="col-7 col-xl-4 col-sm-6 p-0">
                    <button
                        type="button"
                        id="helpShareFeedback"
                        class="btn btn-outline-primary btn-block rounded-lg font-sm font-weight-medium text-capitalize py-2"
                        @click="openQualtrics()"
                    >
                        Share Feedback
                    </button>
                </div>
            </div>
        </template>

        <hr class="my-4" />
        <div class="d-flex flex-column px-4 pb-4">
            <span
                class="font-sm font-weight-bold text-gray-dk text-capitalize mb-5"
                >Need Assistance?</span
            >
            <div class="col-7 col-xl-4 col-sm-6 p-0">
                <button
                    type="button"
                    id="helpContactUs"
                    class="btn btn-outline-primary btn-block rounded-lg font-sm font-weight-medium text-capitalize py-2"
                    @click="redirectToContactUs"
                >
                    Contact Us
                </button>
            </div>
        </div>
        <button
            type="button"
            @click="goBacktoPrevious"
            class="btn btn-link-success font-weight-bold font-xs text-green px-4 mb-3"
        >
            Back
        </button>
    </div>
</template>
<script>
export default {
    created() {
        if (this.$root.$data.transaction.page == "lazada") {
            this.transType = "WT";
            this.referenceNumber = "";
        } else {
            this.transType =
                this.$root.$data.transaction.referenceNumber.substring(0, 2);
            this.referenceNumber = this.$root.$data.transaction.referenceNumber;
        }
        let g4params = {
            userId: this.$root.$data.account.userId,
            cuid: this.$root.$data.account.cuid,
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type: this.transType,
            transaction_reference: this.referenceNumber,
        };
        this.$root.triggerG4Event("help_screen_page", g4params);
    },
    methods: {
        changeView(view) {
            this.$root.$data.view = view;
        },
        redirectToLink(link) {
            window.location.href = link;
        },
        redirectToHCPayVideos() {
            window.location.href = "https://homecredit.ph/hcpay#how-to";
        },
        redirectToContactUs() {
            window.location.href = "https://homecredit.ph/contact-us/";
        },
        goBacktoPrevious() {
            this.$root.$data.view = this.$root.$data.previousView;
        },
        openQualtrics() {
            const qualtricsBtnEl = document.getElementById(
                "QSIFeedbackButton-btn"
            );
            if (!qualtricsBtnEl) {
                return;
            }
            qualtricsBtnEl.click();
        },
    },
    data() {
        const qualtricsBtnEl = document.getElementById("QSIFeedbackButton-btn");

        return {
            qualtricsEnabled: !!qualtricsBtnEl,
            videos: [
                {
                    title: "Pay with your Home Credit Card",
                    link: "https://homecredit.ph/credit-card/",
                },
                {
                    title: "Pay with Home Credit Qwarta",
                    link: "https://homecredit.ph/qwarta/",
                },
            ],
        };
    },
};
</script>
<style scoped>
.headerDivider {
    border-top: 3px solid #fafafa;
}
.chevronIcon {
    height: auto;
    width: 1.5rem;
}
</style>
